import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import { useTargetConstants } from "Hooks/target/useTargetConstants";
import ConfirmationModal from "Components/modal/Modal/ConfirmationModal";
import { IconTarget } from "Assets/index";
import { useStyles } from "./styles";
import { useFormContext } from "react-hook-form";
import ToggleWithText from "Components/formControls/HookFields/ToggleWithText";

const PublishConfirmation = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { methods } = useTargetConstants();
  // const { watch, setValue } = methods;
  const { register } = useFormContext();
  // const { saveToTemplateLibrary: watchSaveToTemplateLibrary } = watch();

  return (
    <ConfirmationModal
      {...props}
      icon={<IconTarget />}
      buttonText={{
        okButton: "Yes, absolutely",
        cancelButton: "No, take me back",
      }}
      title="Publish the target?"
      formContent={
        <Box textAlign="left" className={classes.modalDivider} pt={2}>
          <Typography variant="body2">
            Do you think this target will be repeated again in the future?
          </Typography>
          <ToggleWithText
            register={register(`saveToTemplateLibrary`)}
            name="createTemplate"
          />
        </Box>
      }
    />
  );
};

export default PublishConfirmation;
